// extracted by mini-css-extract-plugin
export default {"textWrapper":"Politics_textWrapper__q2mt9","title":"Politics_title__n+Khd","title_number":"Politics_title_number__uk1Ou"};